import React, {useState} from "react";
import styles from './ProjectGallery.module.scss';

type Props = {
    images: Array<string>;
    videoUrl?: string | null;
};

const ProjectGallery = ({images, videoUrl}: Props) => {
  const [index, setIndex] = useState(0);

  const showPrev = () => setIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  const showNext = () => setIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));

  return (
    <div className={styles.projectGallery}>
      <div className={styles.projectGallery__frame}>
        {images.length > 0 ? (
          <img className={styles.projectGallery__image} src={images[index]} alt=""/>
        ) : (
          <div className={styles.projectGallery__placeholder}>
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="2.5" y="4.5" width="19" height="15" rx="2" stroke="currentColor" strokeWidth="1.5"/>
              <circle cx="8" cy="10" r="1.75" stroke="currentColor" strokeWidth="1.5"/>
              <path d="M3 16.5L8.5 12L13 15.5L16.5 12.5L21 16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span>Фото проекта появятся позже</span>
          </div>
        )}
        {images.length > 1 && (
          <>
            <button
              type="button"
              className={`${styles.projectGallery__arrow} ${styles['projectGallery__arrow--prev']}`}
              onClick={showPrev}
              aria-label="Предыдущее фото"
            />
            <button
              type="button"
              className={`${styles.projectGallery__arrow} ${styles['projectGallery__arrow--next']}`}
              onClick={showNext}
              aria-label="Следующее фото"
            />
          </>
        )}
      </div>
      {videoUrl ? (
        <a className={styles.projectGallery__video} href={videoUrl} target="_blank" rel="noreferrer">
          Смотреть видеопрезентацию проекта
        </a>
      ) : null}
    </div>
  );
};

export default ProjectGallery;
